<template lang="pug">
    p(v-if='this.objeto.acumulado') Saldo acumulado: s/ {{arreglo_acumulado.reduce((a, b)=>a+b, 0)}}
</template>
<script>

export default {
    data: ()=>({
        arreglo_acumulado: []
    }),
    created(){
        Object.keys(this.objeto.saldo).map(item=>this.arreglo_acumulado.push(this.objeto.saldo[item].saldo))
    },
    props: {
        objeto: Object
    },

}
</script>